// config.jaumemimo.js
  /*
   ESO BATXILLERAT I CICLES (Edèn)


germansAlCentre? 
progenitor1Conviu 
progenitor2Conviu
llenguaEstrangera Angles|Alemany /?????

llenguesEntenc    ca|es|xx
llenguesUsHabitual ca|es
llenguesUsFamiliar ca|es|xx|oo

llibreVacunes ?????



  authCompromis
  authGDPR
  authDretsImatge
  authSortides
  authAMPA
  authMedica
  authResponsable
  authPortatils
  authRecursosDigitals
  authDocumentacioExtra
  authAlumnatEstranger
  authErasmus
  authPractiquesEmpresa
  authRecursosDigitals
  authDocumentacioExtra
  authAlumnatEstranger
  authErasmus
  authPractiquesEmpresa
  */

const textInscripcioText = () =>  {

  //return (<>CONSULTEU LA <a href="http://www.inscavallbernat.cat/" target="_blank" rel="noreferrer">PÀGINA WEB DE L'INSTITUT CAVALL BERNAT</a> PER INFORMAR-VOS DEL MATERIAL I ELS LLIBRES QUE NECESSITEU PER INICIAR EL CURS</>)
  return (<></>)

}

const config =
{
    cid: 'a8044715',
    phone: "93 580 39 94",
    email: "a8044715@xtec.cat",

    headerLogo:  'img/logo_bn_jaumemimo.png',
    headerTitle:  'Institut Jaume Mimó',
    headerURL: 'https://matricula.insjaumemimo.cat/',

    //enrollmentPostURL: 'https://matricula.insjaumemimo.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.insjaumemimo.cat/api/',
    apiURL: '/api/',

    textIntroductori: true,

    popupInicial: true,

    /* dadesPersonals */

    validaIDdocuments: true,
    tipusDocTSI: true,
    
    fotoCarnet: true,
    
    anysDefecte: 18,

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    validaTelefonsDuplicats: true,

    conviuAmbProgenitor: true,

    germansAlCentre: true,

    llengues: true,

    contacteEmergenciaObligatori: true,

    /* dadesMediques */

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    /* dadesEstudis */

    //datesNoBloquejenInscripcio: false,
    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    llibreVacunacions: true,

    notesAcces: false,

    mostraTorns: false,

    logo: 'img/logo_jaumemimo.jpg',
    titol: 'INS Jaume Mimó',

    favicon: '/img/favicon-jaumemimo.ico',
    faviconGestio: '/gestio/img/favicon-jaumemimo.ico',

    assignatures: 'assignatures/assignatures.jaumemimo.json',
    families: 'families/families.jaumemimo.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.jaumemimo.json',
    calculquota: 'quotes.jaumemimo.json',

    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textTriarAssignatures: {
      },

    textTriarAssignaturesNous: {
      CFGM:  "(Recodem que pels alumnes nous al centre i que inicien els estudis per als quals van a matricular-se és <b>obligatori matricular-se de tots els mòduls de 1r curs </b>)",
      CFGS:  "(Recodem que pels alumnes nous al centre i que inicien els estudis per als quals van a matricular-se és <b>obligatori matricular-se de tots els mòduls de 1r curs </b>)",
      },


    textBotoMatricular: "INSCRIURE",

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    textProporcionarPreinscripcioNous: "Cal proporcionar número de preinscripció, adjuntar títol pel qual s'accedeix per poder proseguir amb la matrícula de CFGM i CFGS.",

    urlTPV: "",
    pagamentTPV: false,
    pagamentTransferencia: true,

    textInscripcioText: null,

    /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
    dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 6),
    /* si es fals mostrem unes altres condicions de pagament */
    dosTerminisEnabledFalseCondicio: 0,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    sexeNoBinari: true,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;
